import { useNavigate } from 'react-router-dom';

import ListPage from '../../components/ListPage';

import Copy from '../../components/ListPage/components/ActionsToolbar/components/Copy';
import Delete from '../../components/ListPage/components/ActionsToolbar/components/Delete';
import Rename from '../../components/ListPage/components/ActionsToolbar/components/Rename';
import Share from '../../components/ListPage/components/ActionsToolbar/components/Share';

import { deleteInstantSurvey, patchInstantSurvey } from '@api/instant_survey';
import {
  deleteSurveys,
  readSurveys,
  surveyPageSize,
  surveyStatus,
  updateSurveyTitle,
} from '@api/surveys';

import { FILTER_OPTIONS, ITEM_COLUMNS } from './utilities/helpers.js';

const Surveys = () => {
  const navigate = useNavigate();

  const expandSurveyRow = ({ atlasInstantSurveyRef, id, instantSurveyTypeId, status }) => {
    switch (status) {
      case surveyStatus.DRAFT:
        const params = { id };
        if (atlasInstantSurveyRef) params.ref = atlasInstantSurveyRef;
        navigate({
          pathname: `/dashboard/create-survey/${instantSurveyTypeId}`,
          search: new URLSearchParams(params).toString(),
        });
        break;
      case surveyStatus.COMPLETED:
      case surveyStatus.MET_SAMPLE:
        navigate({ pathname: `/dashboard/survey/${id}` });
        break;
      default:
        break;
    }
  };

  const handleDeleteSurveys = async (surveys) => {
    return await Promise.all([
      deleteSurveys({ ids: surveys.map(({ id }) => id) }),
      ...surveys
        .filter(({ atlasInstantSurveyRef }) => atlasInstantSurveyRef)
        .map(({ atlasInstantSurveyRef }) => deleteInstantSurvey({ id: atlasInstantSurveyRef })),
    ]);
  };

  const handleRenameSurvey = async ({ name, row: survey }) => {
    return await Promise.all([
      updateSurveyTitle({ id: survey.id, name }),
      ...(survey.atlasInstantSurveyRef
        ? [patchInstantSurvey({ data: { title: name }, id: survey.atlasInstantSurveyRef })]
        : []),
    ]);
  };

  return (
    <ListPage
      filterOptions={FILTER_OPTIONS}
      itemActions={[
        <Copy redirect="/dashboard/create-survey" type="Survey" />,
        <Rename type="Survey" updateName={handleRenameSurvey} />,
        <Share
          hasAllColleagues={false}
          hasFindColleagues={false}
          hasSharePublicly
          hideOnMultiSelect
          isSurvey={true}
        />,
        <Delete deleteItems={handleDeleteSurveys} />,
      ]}
      itemColumns={ITEM_COLUMNS}
      itemSize={surveyPageSize}
      onCreate={() => navigate('/dashboard/verifiedvoices/instant-surveys')}
      onExpandItemRow={expandSurveyRow}
      readItems={readSurveys}
      type="Survey"
    />
  );
};

export default Surveys;
